import React from 'react';
import cx from 'classnames';

import OfferStatusTooltip from 'modules/fleet/offer-status-tooltip';
import { ReactComponent as LockedIcon } from 'assets/icons/locked.svg';
import { ReactComponent as NotOfferedIcon } from 'assets/icons/not-offered.svg';
import { ReactComponent as StarIcon } from 'assets/icons/star.svg';

import { cellWidth, isLocked } from 'utils/itineraries';
import styled from 'styled-components';

const CustomPoolIcon = styled(NotOfferedIcon)`
  fill: #fff;
  background-color: var(--primary300);
`;

const ListIndicatorChild = ({ itinerary }) => {
  if (!itinerary) {
    return null;
  }

  if (isLocked(itinerary)) {
    return (
      <span className="lock-icon" data-testid="dispatchingListItem_indicator_locked">
        <LockedIcon />
      </span>
    );
  }

  if (itinerary?.is_launched_as_upgrade) {
    return (
      <span
        className="upgrade-icon"
        data-testid="dispatchingListItem_indicator_launched_as_upgrade"
      >
        <StarIcon />
      </span>
    );
  }

  if (itinerary?.is_targeted) {
    return (
      <span className="custom-pool-icon">
        <CustomPoolIcon />
      </span>
    );
  }

  if (!itinerary?.is_launched) {
    return (
      <span data-testid="dispatchingListItem_indicator_notLaunched">
        <NotOfferedIcon />
      </span>
    );
  }

  return null;
};

const ListIndicator = ({ itinerary }) => {
  return (
    <OfferStatusTooltip itinerary={itinerary}>
      <span
        className={cx('cell__indicator pointer', {
          cell__indicator__locked: isLocked(itinerary),
        })}
        data-testid="dispatchingListItem_indicator"
        {...cellWidth('36px')}
      >
        <ListIndicatorChild itinerary={itinerary} />
      </span>
    </OfferStatusTooltip>
  );
};

export default ListIndicator;
